module.exports = __webpack_public_path__ + "static/media/marker.00d4d3a7.svg";